import { processorsFilterBarConfig } from './filterBars';

import type { LayoutPageConfig } from './types';

export const processorsPageConfig = {
  namespacesRequired: ['processors'],
  layout: {
    filterBar: processorsFilterBarConfig,
    noPaddedContent: true,
  },
} satisfies LayoutPageConfig;
